import React from "react";
import { formatRatioDisplay, getRatioColorClass, BASELINE_COMPARISON_TOOLTIP } from "./utils";

const VsCell = ({ value, ratio, distribution, baselineMedian, patternMedian, treatZeroAsMissing, title }) => {
  const showAsMissing = value == null || (treatZeroAsMissing && value === 0);
  const diff = showAsMissing ? null : formatRatioDisplay(ratio);
  if (!diff) return <span className={getRatioColorClass(null)}>—</span>;

  return (
    <span
      className={`text-xs whitespace-nowrap font-medium ${getRatioColorClass(ratio)}`}
      title={title ?? BASELINE_COMPARISON_TOOLTIP}
    >
      {diff.text}
    </span>
  );
};

export default VsCell;
